import Analytics from "./pages/Analytics";

const analyticsRoutes = [
  {
    path: "analytics",
    element: <Analytics />,
  },
];

export default analyticsRoutes;
